module.exports = __webpack_public_path__ + "peru.svg?b49d47529ccf9cd396d320a39e2ef860";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/peru.svg
// module id = 265
// module chunks = 10